import { render, staticRenderFns } from "./VergiNumarasiKurumForm.vue?vue&type=template&id=1de14912&scoped=true"
import script from "./VergiNumarasiKurumForm.vue?vue&type=script&lang=ts"
export * from "./VergiNumarasiKurumForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de14912",
  null
  
)

export default component.exports